import { ComponentToPrint } from './ComponentToPrintResep';
import React, { useRef, useState, useEffect } from "react";
import { useReactToPrint } from "react-to-print";
import ticket from "../../../assets/font-awesome/white/png/128/medkit.png";
import ticket2 from "../../../assets/font-awesome/black/png/128/medkit.png";

function Preview({ item }) {
  const [dataLoaded, setDataLoaded] = useState(false);
  const onBeforeGetContentResolve = useRef();
  const componentRef = useRef();

  const handleOnBeforeGetContent = () => {
    return new Promise((resolve) => { // `react-to-print` will wait for this Promise to resolve before continuing
      // Load data
      onBeforeGetContentResolve.current = resolve;
      setDataLoaded(true); // When data is done loading

      setTimeout(() => {
        setDataLoaded(false);
      }, 2000);

    });
  };

  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
    onBeforeGetContent: handleOnBeforeGetContent,
  });

  useEffect(() => {
    if (dataLoaded) {
      // Resolves the Promise, telling `react-to-print` it is time to gather the content of the page for printing
      onBeforeGetContentResolve.current();
    }
  }, [dataLoaded, onBeforeGetContentResolve]);

  return (
    <div className="bg-gray-200 p-6"
      style={{ cursor: item.CATATAN_RESEP == '[{ "r": "", "s": "" }]' || item.CATATAN_RESEP == '[]' || item.CATATAN_RESEP == null ? 'not-allowed' : null }}>
      <button onClick={handlePrint}
      title="Print Resep"
        disabled={item.CATATAN_RESEP == '[{ "r": "", "s": "" }]' || item.CATATAN_RESEP == '[]' || item.CATATAN_RESEP == null ? true : false}
        className={item.CATATAN_RESEP == '[{ "r": "", "s": "" }]' || item.CATATAN_RESEP == '[]' || item.CATATAN_RESEP == null ? "btn btn-light btn-sm rounded-0" : "btn btn-danger btn-sm rounded-0"}
        style={{ backgroundImage: item.CATATAN_RESEP == '[{ "r": "", "s": "" }]' || item.CATATAN_RESEP == '[]' || item.CATATAN_RESEP == null ? "url(" + ticket2 + ")" : "url(" + ticket + ")", backgroundSize: "cover", backgroundSize: '20px', backgroundPosition: 'center', backgroundRepeat: 'no-repeat', width: "30px", height: "30px" }}>
      </button>
      <ComponentToPrint item={item} ref={componentRef} />
    </div>
  );
}

export default Preview;



